import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssessmentIcon from '@mui/icons-material/Assessment';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { IApplyJobStep } from "./ApplyJobModel";

export enum ECandidateFlow {
    ApplyJob = 'apply-job',
    Survey = 'survey',
}

export const ApplyJobSteps: IApplyJobStep[] = [
    {
        label: 'Details',
        path: '',
        value: 0,
        stepIcon: <AccountCircleIcon />

    },
    {
        label: 'Questionnaire',
        path: 'questionnaire',
        value: 1,
        stepIcon: <QuestionAnswerIcon />
    },
    {
        label: 'Assessment',
        path: 'assessment',
        value: 2,
        stepIcon: <AssessmentIcon />
    }
];